class ValidationText {
	static FIELD_REQUIRED = 'This field is required';
	static FILE_EXTENSION_MESSAGE =
		'Format should be doc,docx,pdf and size must be less than 2 MB';
	static ALREADY_EXIST = 'Username Already Exist';
	static DYANMIC_ARRAY_VALIDATION = 'Please fill the form properly!';
}

export default ValidationText;
